import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MaterialModule } from '../material/material.module';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './page/login/login.component';
import { LogoutComponent } from './page/logout/logout.component';


@NgModule({
  declarations: [LoginComponent, LogoutComponent],
  imports: [
    AuthRoutingModule,
    MaterialModule,
    CommonModule,
    FormsModule,
  ],
  providers:  []
})
export class AuthModule { }